// ===================================================
// IMPORTAÇÃO DE EXTRATO BANCÁRIO
// ===================================================

// Auto-categorization rules (keyword → {tipo, cat})
const EXTRATO_REGRAS = [
  // Entradas
  {kw:['pix recebido','transferencia recebida','ted recebida','doc recebido','deposito','entrada'],tipo:'entrada',cat:'Venda'},
  // Fixos
  {kw:['aluguel'],tipo:'saida',cat:'Aluguel'},
  {kw:['copasa','sabesp','saneago','agua','saneamento'],tipo:'saida',cat:'Água'},
  {kw:['cemig','cpfl','celpe','coelba','enerjisa','neoenergia','light','enel','eletropaulo','energia','eletricidade'],tipo:'saida',cat:'Energia'},
  {kw:['folha','salario','holerite','funcionario','clt'],tipo:'saida',cat:'Folha de pagamento'},
  {kw:['microsoft','office 365','m365'],tipo:'saida',cat:'Software'},
  // Variáveis
  {kw:['material','marmore','granito','pedra','quartzo','chapa','fornecedor'],tipo:'saida',cat:'Material'},
  {kw:['frete','transporte','logistica','entrega'],tipo:'saida',cat:'Frete'},
  {kw:['manutencao','reparo','conserto'],tipo:'saida',cat:'Manutenção'},
  {kw:['consultoria','consultor'],tipo:'saida',cat:'Consultoria'},
  {kw:['imposto','das','iss','ir ','irpj','csll','pis','cofins','tributo','inss','fgts'],tipo:'saida',cat:'Impostos'},
  {kw:['maquina','financiamento','parcela','bmg','banco pan','caixa economica cred'],tipo:'saida',cat:'Máquina'},
  {kw:['pix enviado','transferencia enviada','ted enviada','pagamento'],tipo:'saida',cat:'Outros'},
];

function categorizarLinha(desc){
  const d = (desc||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  for(const r of EXTRATO_REGRAS){
    if(r.kw.some(k=>d.includes(k))) return {tipo:r.tipo,cat:r.cat,confianca:'média',regra:r.kw.find(k=>d.includes(k))||''};
  }
  return {tipo:null,cat:'A classificar',confianca:'sem correspondência',regra:''};
}

function parseValorBR(str){
  if(!str) return 0;
  str = str.toString().replace(/\s/g,'');
  // Handle formats: -1.234,56 or -1234.56 or 1.234,56 or 1234,56
  const neg = str.startsWith('-') || str.startsWith('D') || str.endsWith('D');
  str = str.replace(/[^\d.,]/g,'');
  if(str.includes(',') && str.includes('.')){
    // Assume comma is decimal: 1.234,56
    str = str.replace(/\./g,'').replace(',','.');
  } else if(str.includes(',')){
    str = str.replace(',','.');
  }
  const val = parseFloat(str)||0;
  return neg ? -Math.abs(val) : val;
}

function parseDataBR(str){
  if(!str) return '';
  str = str.trim();
  // DD/MM/YYYY or DD/MM/YY
  const m1 = str.match(/^(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?/);
  if(m1){
    const y = m1[3]?parseInt(m1[3]):new Date().getFullYear();
    const yr = y<100?(y>50?1900+y:2000+y):y;
    return `${yr}-${m1[2].padStart(2,'0')}-${m1[1].padStart(2,'0')}`;
  }
  // YYYY-MM-DD
  const m2 = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m2) return m2[0];
  return '';
}

// OFX parser
function parseOFX(text){
  const txns = [];
  const txnBlocks = text.split(/<STMTTRN>/).slice(1);
  txnBlocks.forEach(blk => {
    const get = tag => { const m = blk.match(new RegExp('<'+tag+'>([^<\\n\\r]+)')); return m?m[1].trim():''; };
    const dtstr = get('DTPOSTED');
    const date = dtstr ? `${dtstr.slice(0,4)}-${dtstr.slice(4,6)}-${dtstr.slice(6,8)}` : '';
    const val = parseFloat(get('TRNAMT').replace(',','.'))||0;
    const desc = get('MEMO')||get('NAME')||'';
    const fitid = get('FITID');
    if(date && val!==0) txns.push({date, desc, val, fitid, documento:get('CHECKNUM')||get('REFNUM')||'', linhaOriginal:blk.trim()});
  });
  return txns;
}

// CSV parser (generic)
function parseCSV(text){
  const lines = text.split('\n').map(l=>l.trim()).filter(Boolean);
  const txns = [];
  lines.forEach(line => {
    const cols = line.split(/[;,\t]/);
    if(cols.length < 2) return;
    // Try to find date, desc, value across columns
    let date='', desc='', val=0;
    for(let i=0;i<cols.length;i++){
      const c = cols[i].trim().replace(/"/g,'');
      if(!date && /\d{1,2}[\/\-]\d{1,2}/.test(c)) date=parseDataBR(c);
      else if(!val && /^-?[\d.,]+$/.test(c.replace(/\s/g,''))) { val=parseValorBR(c); }
      else if(!desc && c.length>3 && !/^\d/.test(c)) desc=c;
    }
    if(date && val!==0) txns.push({date,desc,val,linhaOriginal:line});
  });
  return txns;
}

// Free text parser (copy-paste from app)
function parseTextoLivre(text){
  const txns = [];
  const lines = text.split('\n').map(l=>l.trim()).filter(Boolean);
  lines.forEach(line => {
    // Pattern: "10/06 DESCRIÇÃO -250,00" or "10/06/2025 DESCRIÇÃO 250,00 D"
    const m = line.match(/(\d{1,2}[\/\-]\d{1,2}(?:[\/\-]\d{2,4})?)\s+(.+?)\s+([-+]?\d[\d.,]*(?:\s*[DC])?)\s*$/);
    if(m){
      const date = parseDataBR(m[1]);
      const desc = m[2].trim();
      const val = parseValorBR(m[3]);
      if(date && val!==0) txns.push({date,desc,val,linhaOriginal:line});
    }
  });
  return txns;
}

function txnsToReview(txns){
  return txns.map((t,idx)=>{
    const cat = categorizarLinha(t.desc);
    const tipo=cat.tipo||(Number(t.val)>=0?'entrada':'saida');
    return {...t, tipo, cat:cat.cat, confianca:cat.confianca, regra:cat.regra, importar:true, descricaoOriginal:t.desc||'', descricaoInterna:t.desc||'', linhaOriginal:t.linhaOriginal||`${t.date||''} ${t.desc||''} ${t.val||''}`, indiceOrigem:idx};
  });
}

